import { Grid } from '@mui/material'
import { AuthSessionContext } from 'api/AuthSession'
import axios from 'api/axios-configure'
import { UITableReport } from 'components/UITableReport'
import format from 'date-fns/format'
import { useContext, useEffect, useMemo, useState, useRef } from "react"
import { ArrowLeft } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Button, Tooltip } from 'monday-ui-react-core'
import UploadReceiverDetailsModal from './UploadReceiverDetailsModal';
import UploadReceiverDetailsErrorModal from './UploadReceiverDetailsErrorModal'
import { Row, Col } from 'react-bootstrap'
import { Trash3, CheckCircle, DashCircle } from 'react-bootstrap-icons'

const OrganizationReceiverDetail = ({open, onBack, senderName, senderNumber, documentType}) => {
    const {IS_USER} = useContext(AuthSessionContext)
    const [isLoading, setIsLoading] = useState(false)
    const [isFetching, setIsFetching] = useState(false)
    const [tableData, setTableData] = useState([])
    const inputFile = useRef(null)
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [uploadError, setUploadError] = useState("")
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [csvErrors, setCsvErrors] = useState()

    const [columnVisibility, setColumnVisibility] = useState({
        registrationCode: IS_USER ? false : true,
        organizationLinkCreateDate: false,
        createDate: false,
        actions: IS_USER ? false : true
    })

    const columns = useMemo(() => {
        if (IS_USER) {
            return [
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'sourceNumber',
                    header: 'Source Number'
                },
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'name',
                    header: 'Name'
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'registrationCode',
                    header: 'Registration Code'
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'organizationNumber',
                    header: 'Organization #'
                },
                {
                    size: 200,
                    maxSize: 200,
                    accessorKey: 'organizationName',
                    header: 'Organization Name'
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'userActivity',
                    header: 'User Activity',
                    Cell: ({ cell }) => {
                        const dateString = cell.getValue()
                        if (!dateString) return <></>
                        const date = new Date(dateString)
                        const result = format(date, 'MM/dd/yyyy hh:mm')
                        return <>{result}</>
                    }
                },
                {
                    size: 60,
                    maxSize: 100,
                    accessorKey: 'hasDocuments',
                    header: 'Documents',
                    muiTableBodyCellProps: {
                        align: 'center',
                    },
                    Cell: ({ cell }) => {
                        const hasDocuments = cell.getValue()
                        if (hasDocuments) return <><Tooltip size={20} content="Documents Exist">
                                                    <CheckCircle></CheckCircle></Tooltip></>
                        else return <><Tooltip size={20} content="No Documents Found">
                                                    <DashCircle></DashCircle></Tooltip></>
                    }
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'organizationLinkCreateDate',
                    header: 'Organization Link Date',
                    Cell: ({ cell }) => {
                        const dateString = cell.getValue()
                        if (!dateString) return <></>
                        const date = new Date(dateString)
                        const result = format(date, 'MM/dd/yyyy hh:mm')
                        return <>{result}</>
                    },
                },
                {
                    size: 100,
                    maxSize: 100,
                    accessorKey: 'createDate',
                    header: 'Create Date',
                    Cell: ({ cell }) => {
                        const dateString = cell.getValue()
                        if (!dateString) return <></>
                        const date = new Date(dateString)
                        const result = format(date, 'MM/dd/yyyy hh:mm')
                        return <>{result}</>
                    }
                }
            ]
        } else {
                return [
                    {
                        size: 200,
                        maxSize: 200,
                        accessorKey: 'sourceNumber',
                        header: 'Source Number'
                    },
                    {
                        size: 200,
                        maxSize: 200,
                        accessorKey: 'name',
                        header: 'Name'
                    },
                    {
                        size: 100,
                        maxSize: 100,
                        accessorKey: 'registrationCode',
                        header: 'Registration Code'
                    },
                    {
                        size: 100,
                        maxSize: 100,
                        accessorKey: 'organizationNumber',
                        header: 'Organization #'
                    },
                    {
                        size: 200,
                        maxSize: 200,
                        accessorKey: 'organizationName',
                        header: 'Organization Name'
                    },
                    {
                        size: 100,
                        maxSize: 100,
                        accessorKey: 'userActivity',
                        header: 'User Activity',
                        Cell: ({ cell }) => {
                            const dateString = cell.getValue()
                            if (!dateString) return <></>
                            const date = new Date(dateString)
                            const result = format(date, 'MM/dd/yyyy hh:mm')
                            return <>{result}</>
                        }
                    },
                    {
                        size: 60,
                        maxSize: 100,
                        accessorKey: 'hasDocuments',
                        header: 'Documents',
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                        Cell: ({ cell }) => {
                            const hasDocuments = cell.getValue()
                            if (hasDocuments) return <><Tooltip content="Documents Exist">
                                                        <CheckCircle size={20}></CheckCircle></Tooltip></>
                            else return <><Tooltip content="No Documents Found">
                                                        <DashCircle size={20}></DashCircle></Tooltip></>
                        }
                    },
                    {
                        size: 100,
                        maxSize: 100,
                        accessorKey: 'organizationLinkCreateDate',
                        header: 'Organization Link Date',
                        Cell: ({ cell }) => {
                            const dateString = cell.getValue()
                            if (!dateString) return <></>
                            const date = new Date(dateString)
                            const result = format(date, 'MM/dd/yyyy hh:mm')
                            return <>{result}</>
                        },
                    },
                    {
                        size: 100,
                        maxSize: 100,
                        accessorKey: 'createDate',
                        header: 'Create Date',
                        Cell: ({ cell }) => {
                            const dateString = cell.getValue()
                            if (!dateString) return <></>
                            const date = new Date(dateString)
                            const result = format(date, 'MM/dd/yyyy hh:mm')
                            return <>{result}</>
                        }
                    },
                    {
                        header: 'Actions',
                        size: 60,
                        enableSorting: false,
                        maxSize: 60,
                        accesorKey: 'actions',
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                        Cell: ({row}) => {
                            return (
                                (row.original.organizationNumber !== null && row.original.organizationNumber !== '' || row.original.hasDocuments ) ? 
                                <div disabled>
                                    <Tooltip content="Delete">
                                        <Trash3 disabled style={{cursor: 'not-allowed', color:'grey'}}
                                            className='payout-icon'
                                            size={20}
                                        />
                                    </Tooltip>
                                </div>
                                :
                                <div>
                                <Tooltip content="Delete">
                                    <Trash3 
                                        className='payout-icon'
                                        size={20}
                                        onClick={() => handleRemoveClick(row.original.id)}
                                    />
                                </Tooltip>
                            </div>
                            )
                        }
                    }
                ]
            }
        }
    )

    const handleRemoveClick = (rowId) => {
        setIsFetching(true)
        axios
            .delete(`/DeleteMasterCompanyReceiver?mcrId=${rowId}`)
            .then(response => {
                loadPage()
                toastSuccess('Master company receiver deleted successfully.')
            })
            .catch(err => {
                setIsFetching(false)
                toastError('There was an error deleting the master company receiver.')
            })
            .finally(() => {
            })

    }

    const loadPage = () => {
        if (!tableData.length) {
            setIsLoading(true)
        } else {
            setIsFetching(true)
        }

        axios.get(`/GetOrganizationReceiverDetails?senderNumber=${senderNumber}&documentType=${documentType}`)
            .then(response => {
                setTableData(response.data)
            })
            .catch(err => { 
                console.error(err)
                setIsLoading(false)
                setIsFetching(false)
                })
            .finally(() => {
                setIsLoading(false)
                setIsFetching(false)
            })
    }

    const handleUploadClick = () => {
        if (selectedFile) {
            const formData = new FormData()
            formData.append('file', selectedFile, selectedFile.name)
            formData.append('senderNumber', senderNumber)
            formData.append('documentType', documentType)
            toastSuccess('Uploading the file')
            closeUploadModal()
            axios
                .post('/UploadReceiverDetails', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(() => {
                    toast.dismiss()
                    toastSuccess('File Uploaded successfully.')
                    loadPage()
                })
                .catch(({ response }) => {
                    handleCsvErrors(response.data)
                    toast.dismiss()
                })
        }
    }

    const handleFileInputClick = () => {
        const file = inputFile.current.files[0]
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension === 'csv' || fileExtension === 'xlsx') {
            setSelectedFile(inputFile.current.files[0])
            setUploadError('')
        } else {
            setUploadError('Only CSV and Excel files are supported.')
        }
    }

    const toastSuccess = (message) => {
        toast.dismiss()
        toast.success(message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const toastError = (message) => {
        toast.dismiss()
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--error-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const downloadDetails = () => {
        var data = {senderName, senderNumber, documentType}
        axios.post("/DownloadReceiverDetails", data)
            .then((response) => {
                if (response.data) {
                    toastSuccess('File downloaded successfully.')
                    const csvContent = "data:text/csv;charset=utf-8," + response.data;
                    const encodedUri = encodeURI(csvContent).replaceAll('#', '%23');
                    const link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    const formattedDate = format(new Date(), "yyyyMMdd")
                    const filename = `energilitydx-receiver-details-${formattedDate}`;
                    link.setAttribute("download", filename);
                    document.body.appendChild(link); 
                    link.click();
                }
            })
            .catch(error => {
                toastError('Error: Please contact your administrator.')
            })
    }

    const closeUploadModal = () => {
        inputFile.current.value = null
        setSelectedFile(null)
        setShowUploadModal(false)
        setUploadError('')
    }

    useEffect(() => {
        if (!open) return;

        loadPage()
    }, [open])

    const uploadButtonClick = () => {
        setShowUploadModal(true)
    }

    const handleCsvErrors = (errorMessage) => {
        setCsvErrors(errorMessage)
        setShowErrorModal(true)
    }

    const closeErrorModal = () => {
        setShowErrorModal(false)
        setCsvErrors(undefined)
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} style={{paddingTop: '0px'}}>
                    <Link
                        className="d-flex align-items-center"
                        onClick={onBack}
                    >
                        <ArrowLeft size={13} />
                        <span className="ml-2"> Back</span>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2>Organization</h2>
                </Grid>
                <Grid item xs={12}>
                    <Row>
                        <Col> 
                            <h4>{senderName} - {documentType}</h4>
                        </Col>
                        {!IS_USER ? (
                            <Col style={{ textAlign: 'end' }}>                       
                                <Tooltip content="Download Receiver List">
                                    <Button style={{width:'105px'}}
                                        size={Button.sizes.SMALL}
                                        type={Button.types.BUTTON}
                                        onClick={downloadDetails}
                                        Tooltip
                                    >
                                        Download
                                    </Button>              
                                </Tooltip>
                            </Col>
                            ) : <></>   
                        }   
                        {!IS_USER ? (
                        <Col style={{ textAlign: 'end', maxWidth: 'fit-content', marginLeft: 'inherit', paddingLeft: '5px'}}>
                            <Tooltip content="Upload Receivers">
                                <Button style={{width:'105px', marginLeft: '5px'}}
                                    size={Button.sizes.SMALL}
                                    type={Button.types.BUTTON}
                                    onClick={uploadButtonClick}
                                >
                                    Upload
                                </Button>
                            </Tooltip>
                        </Col>
                            ) : <></>
                    }
                    </Row>
                </Grid>
                <Grid item xs={12}>
                    <UITableReport
                        columns={columns}
                        data={tableData}
                        isLoading={isLoading}
                        isFetching={isFetching}
                        columnVisibility={columnVisibility}
                        setColumnVisibility={setColumnVisibility}
                    />
                </Grid>
            </Grid>

            {showUploadModal && (
                <UploadReceiverDetailsModal 
                    showModal={showUploadModal}
                    closeModal={closeUploadModal}
                    inputFileRef={inputFile}
                    selectedFile={selectedFile}
                    uploadError={uploadError}
                    handleFileInputClick={handleFileInputClick}
                    handleUploadClick={handleUploadClick}
                />
            )}

            {showErrorModal && (
                <UploadReceiverDetailsErrorModal 
                    showModal={showErrorModal}
                    closeModal={closeErrorModal}
                    csvErrors={csvErrors}
                />
            )}
        </>
    )
}

export default OrganizationReceiverDetail